import * as React from 'react'

import { cn } from '@/lib/utils'
import { Button } from '../primitives/Button'

interface ActionButtonProps {
  onClick: () => void
  icon?: React.ReactNode
  children: React.ReactNode
  variant?: 'primary' | 'secondary' | 'danger'
  disabled?: boolean
  className?: string
  title?: string
  size?: 'sm' | 'md' | 'lg'
}

export function ActionButton({
  onClick,
  icon,
  children,
  variant = 'primary',
  disabled = false,
  className,
  title,
  size = 'md',
}: ActionButtonProps) {
  const variantMap = {
    primary: 'default' as const,
    secondary: 'outline' as const,
    danger: 'destructive' as const,
  }

  return (
    <Button
      className={cn(className)}
      disabled={disabled}
      icon={icon}
      iconPosition="left"
      onClick={onClick}
      size={size}
      title={title}
      variant={variantMap[variant]}
    >
      {children}
    </Button>
  )
}
